import React from "react"
import { useSelector } from "react-redux"
import { Button, Card } from "reactstrap"
import CardBody from "reactstrap/lib/CardBody/"
import { getSportsConfig } from "../../utility/constants/sportConfig"
import styles from "./ScoreCounter.module.scss"
import ScoreViewer from "./ScoreViewer/"

const ScoreCounterVolleyball = ({ addSet, subtitle }) => {
	const { winnerPoints, deuce } = getSportsConfig(localStorage.getItem("sport"))
	const spectate = localStorage.getItem("spectate")

	const homeTeam = JSON.parse(localStorage.getItem("homeTeam") ?? "{}")
	const awayTeam = JSON.parse(localStorage.getItem("awayTeam") ?? "{}")
	const { score, isMatchDone } = useSelector((state) => {
		return {
			score: state.scoreCounter,
			isMatchDone:
				state.penaltiesOrEnd === "done" ||
				state.penaltiesOrEnd === "forfeit",
		}
	})
	const homeTeamWon =
		score.homeTeam > winnerPoints && score.homeTeam > score.awayTeam + deuce
	const awayTeamWon =
		score.awayTeam > winnerPoints && score.awayTeam > score.homeTeam + deuce

	const disableHomeTeamWin =
		score.homeTeam === score.awayTeam || score.homeTeam < score.awayTeam
	const disableAwayTeamWin =
		score.homeTeam === score.awayTeam || score.homeTeam > score.awayTeam

	const onSetWin = () => addSet(score)

	const getForfeitMessage = () => {
		if (localStorage.getItem("penaltiesOrEnd") != "forfeit") return <></>

		const { isHome, isAway } = JSON.parse(
			localStorage.getItem("forfeitBody") ?? "{}"
		)
		let message = "Obe ekipe su se predale"
		if (isHome && !isAway) {
			const name = JSON.parse(localStorage.getItem("homeTeam") ?? "{}").name
			message = `Ekipa ${name} se predala`
		} else if (!isHome && isAway) {
			const name = JSON.parse(localStorage.getItem("awayTeam") ?? "{}").name
			message = `Ekipa ${name} se predala`
		}
		return <h3 className="text-center">{message}</h3>
	}

	return (
		<Card>
			<CardBody style={{ textAlign: "center" }}>
				<h1 className="text-center m-2">{localStorage.getItem("sport")}</h1>
				{subtitle && <h2 className="text-center m-2">{subtitle}</h2>}

				<div className={styles.wrapper}>
					<div className={styles.alignText}>
						<h3>{`${homeTeam.name} ${homeTeam.surname ?? ""}`}</h3>
						{!isMatchDone && !spectate && (
							<Button.Ripple
								color={!disableHomeTeamWin ? "primary" : "secondary"}
								outline={!homeTeamWon}
								disabled={disableHomeTeamWin}
								onClick={onSetWin}
								className="mb-1"
							>
								Pobjeda Seta
							</Button.Ripple>
						)}
					</div>
					<div className={styles.columnFlex}>
						<ScoreViewer
							score={score}
							isMatchDone={isMatchDone}
							homeTeamWon={homeTeamWon}
							awayTeamWon={awayTeamWon}
						/>
					</div>
					<div className={styles.alignText}>
						<h3>{`${awayTeam.name} ${awayTeam.surname ?? ""}`}</h3>
						{!isMatchDone && !spectate && (
							<Button.Ripple
								color={!disableAwayTeamWin ? "primary" : "secondary"}
								outline={!awayTeamWon}
								disabled={disableAwayTeamWin}
								onClick={onSetWin}
								className="mb-1"
							>
								Pobjeda Seta
							</Button.Ripple>
						)}
					</div>
				</div>

				{getForfeitMessage()}
			</CardBody>
		</Card>
	)
}

export default ScoreCounterVolleyball
